export const isNotificationRead = (notification) => {
  if (!notification || typeof notification !== 'object') {
    return false;
  }
  if (Object.prototype.hasOwnProperty.call(notification, 'read')) {
    return Boolean(notification.read);
  }
  return Boolean(notification.is_read);
};

export const formatNotificationRelativeTime = (dateValue, nowValue = Date.now()) => {
  const parsedDate = new Date(dateValue);
  if (Number.isNaN(parsedDate.getTime())) {
    return '';
  }

  const referenceTime = Number(nowValue || Date.now());
  const diffMs = Math.max(0, referenceTime - parsedDate.getTime());
  const diffMinutes = Math.floor(diffMs / 60000);

  if (diffMinutes < 1) {
    return "a l'instant";
  }
  if (diffMinutes < 60) {
    return `il y a ${diffMinutes} min`;
  }

  const diffHours = Math.floor(diffMinutes / 60);
  if (diffHours < 24) {
    return `il y a ${diffHours} h`;
  }

  const diffDays = Math.floor(diffHours / 24);
  if (diffDays < 7) {
    return `il y a ${diffDays} jour${diffDays > 1 ? 's' : ''}`;
  }

  return parsedDate.toLocaleDateString('fr-FR');
};

export const resolveNotificationNavigation = (notification) => {
  const route = String(
    notification?.resolved_route || notification?.route || notification?.fallback_route || ''
  ).trim() || null;
  const navigationReason = String(notification?.navigation_reason || 'primary').trim().toLowerCase() || 'primary';
  const message = navigationReason !== 'primary'
    ? (String(notification?.navigation_message || '').trim() || null)
    : null;

  return {
    route,
    navigationReason,
    message,
  };
};
